const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("zari_token");
export const getRefresh = () => localStorage.getItem("zari_refresh");

export function formatApiError(err) {
  const detail = err?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return "Algo deu errado. Tente novamente.";
}

async function request(path, { method = "GET", body, auth = false } = {}, retry = true) {
  const headers = { "Content-Type": "application/json" };
  if (auth && getToken()) headers.Authorization = `Bearer ${getToken()}`;
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401 && auth && retry && getRefresh()) {
    const ok = await refreshSession();
    if (ok) return request(path, { method, body, auth }, false);
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw { status: res.status, detail: data.detail };
  return data;
}

export async function refreshSession() {
  try {
    const res = await fetch(`${BASE}/auth/refresh`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh_token: getRefresh() }),
    });
    if (!res.ok) return false;
    const data = await res.json();
    localStorage.setItem("zari_token", data.token);
    return true;
  } catch {
    return false;
  }
}

export const api = {
  projects: () => request("/projects"),
  login: (email, password) => request("/auth/login", { method: "POST", body: { email, password } }),
  me: () => request("/auth/me", { auth: true }),
  adminProjects: () => request("/admin/projects", { auth: true }),
  createProject: (p) => request("/admin/projects", { method: "POST", body: p, auth: true }),
  updateProject: (id, p) => request(`/admin/projects/${id}`, { method: "PUT", body: p, auth: true }),
  deleteProject: (id) => request(`/admin/projects/${id}`, { method: "DELETE", auth: true }),
};
